import React from 'react'
import PropTypes from 'prop-types'
import { HeaderNav, NewFooter, BannerTeaser } from 'newComponents'
import 'typeface-nunito-sans'
import 'typeface-libre-franklin'

import '../styles/bundle.scss'

const Layout = ({ children, invertNavbar, footer, className, staticNavbar, hasBanner, headerLogoOnly }) => (
  <>
    {hasBanner && <BannerTeaser />}
    <HeaderNav invertNavbar={invertNavbar} staticNavbar={staticNavbar} headerLogoOnly={headerLogoOnly} />
    <main className={className || ''} id="main">
      {children}
    </main>
    {footer && <NewFooter />}
  </>
)

Layout.defaultProps = {
  footer: true
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.bool
}

export default Layout
